import TextField from "@/components/layouts/History/TextField";
import { useLicenseServiceItems } from "@/entities/settings/hooks";
import { find } from "lodash";

interface Props {
  value: string;
}

const LicenseTypeName: React.FC<Props> = ({ value }) => {
  const { licenseItems } = useLicenseServiceItems();
  const license = find(licenseItems, (licenseItem) => licenseItem.id === value);
  return <TextField>{license?.name || ""}</TextField>;
};

export default LicenseTypeName;
